import { FC } from 'react';
import { useHistory } from 'react-router';
import { HStack, Image } from '@chakra-ui/react';

import Button from 'components/_core/Button';

import easyImg from '../../../../../../assets/brand/easy.png';
import SunshineCard from '../../../../../../components/_core/SunshineCard';
import * as routes from '../../../../routes';
import locales from '../../locales';

interface EstimationCardProps {
  title: string;
  subtitle: string;
  ctaText: string;
}

const EstimationCtaCard: FC<EstimationCardProps> = ({
  ctaText,
  subtitle,
  title,
}) => {
  const history = useHistory();

  return (
    <SunshineCard alignItems="center">
      <SunshineCard.Content>
        <SunshineCard.Title fontWeight="weight-400" size="lg">
          {title}
        </SunshineCard.Title>
        <SunshineCard.Text>{subtitle}</SunshineCard.Text>
        <HStack alignItems="baseline" gap="space-16">
          <SunshineCard.Button
            icon="arrow-right"
            iconPosition="right"
            marginTop="space-16"
            onClick={() => history.push(routes.microEstimationFlow)}
            variant="primary"
          >
            {ctaText}
          </SunshineCard.Button>
          <Button
            as="a"
            href={locales.faq.url}
            icon="link"
            target="_blank"
            variant="inline-secondary"
          >
            {locales.faq.label}
          </Button>
        </HStack>
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        <Image boxSize="120px" src={easyImg} />
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default EstimationCtaCard;
